import * as React from 'react';
import { cn } from '@noor/lib/cn';

export type TopNavShellMainProps = React.ComponentProps<'main'>;

/**
 * The main content region below the header. A `flex-1 min-h-0` column that
 * provides the bounded, non-scrolling frame; compose a `PageShell` (or any
 * content) inside it to decide scroll behaviour within that box.
 */
function TopNavShellMain({ className, ...props }: TopNavShellMainProps) {
  return (
    <main
      data-slot="top-nav-shell-main"
      className={cn('flex min-h-0 min-w-0 flex-1 flex-col', className)}
      {...props}
    />
  );
}

export { TopNavShellMain };
